import { useEffect, useRef } from 'react'
import { Animated } from 'react-native'
import { Icon } from '~/components/icon'
import { type ScopedProps, useAccordionContext } from '../../accordion'
import * as S from './header.styles'

type THeaderProps = {
  title: string
  index?: number
}

export function Header(props: THeaderProps) {
  const { __scopeAccordion, title, index } = props as ScopedProps<THeaderProps>
  const { expandedIndex, disabled } = useAccordionContext(
    'AccordionHeader',
    __scopeAccordion
  )
  const isCollapsed = expandedIndex !== index

  const rotateAnim = useRef(new Animated.Value(0)).current

  useEffect(() => {
    Animated.timing(rotateAnim, {
      toValue: isCollapsed ? 0 : 1,
      duration: 200,
      useNativeDriver: true,
    }).start()
  }, [isCollapsed, rotateAnim])

  const rotate = rotateAnim.interpolate({
    inputRange: [0, 1],
    outputRange: ['0deg', '180deg'],
  })

  return (
    <S.Header disabled={disabled} isCollapsed={isCollapsed}>
      <S.Title disabled={disabled} numberOfLines={4}>
        {title}
      </S.Title>
      <Animated.View style={{ transform: [{ rotate }] }}>
        <Icon
          symbol="rdicon-chevron-down"
          size="small"
          color={disabled ? 'colorTextNeutralDisabled' : undefined}
        />
      </Animated.View>
    </S.Header>
  )
}
